// 챗봇 대화 안의 카드들(시안 storeCard · sq · 기간 버튼 · 목록)
import React, { useState } from "react";
import { useChatText } from "./text";
import { useLanguage } from "../../i18n/LanguageContext";
import { kindLabel } from "../my/format";
import { StatusTag, StateNote } from "../my/parts";

// 가맹점 확인(시안 storeCard) — 로그인 매장 정보(상호·대표자·주소). 흐름이 지나가면 버튼 비활성
export function StoreCard({ card, active, onAnswer, onHome }) {
    const t = useChatText();
    const c = card.customer || {};
    const rows = [["cf.store.name", c.business_name], ["cf.store.owner", c.owner_name], ["cf.store.addr", c.address]].filter(([, v]) => v);
    return (
        <div className="cf-cardmsg">
            <h4>{t("cf.store.title")}</h4>
            <div className="cf-sub">{t("cf.store.desc")}</div>
            <div className="cf-ibox">
                <div className="cf-sinfo">{rows.map(([k, v]) => <div key={k} className="cf-srow"><span>{t(k)}</span><span>{v}</span></div>)}</div>
                <div className="cf-hint">{t("cf.store.hint")}</div>
            </div>
            <div className="cf-yn">
                <button type="button" className="y" disabled={!active} onClick={() => onAnswer(true)}>{t("cf.yes")}</button>
                <button type="button" className="n" disabled={!active} onClick={() => onAnswer(false)}>{t("cf.no")}</button>
            </div>
            <HomeButton disabled={!active} onClick={onHome} />
        </div>
    );
}

// 시안 home-btn
export function HomeButton({ disabled, onClick }) {
    const t = useChatText();
    return (
        <button type="button" className="cf-home-btn" disabled={disabled} onClick={onClick}>
            <i className="fa-solid fa-house" aria-hidden="true" />{t("nav.home")}
        </button>
    );
}

// 매출 조회 기간 — 접수 내용에는 한국어 이름으로 들어간다
const KO_PERIOD = { h1: "상반기", h2: "하반기", all: "전체" };
export function PeriodCard({ active, onPick }) {
    const t = useChatText();
    const [custom, setCustom] = useState(false);
    const [range, setRange] = useState({ start: "", end: "" });
    return (
        <div className="cf-card">
            <div className="inquiry-period-grid">
                {Object.entries(KO_PERIOD).map(([k, ko]) => (
                    <button key={k} type="button" className="inquiry-period-option" disabled={!active} onClick={() => onPick(ko)}>{t(`cf.period.${k}`)}</button>
                ))}
                <button type="button" className="inquiry-period-option" disabled={!active} onClick={() => setCustom(true)}>{t("cf.period.custom")}</button>
            </div>
            {custom && active && (
                <div className="inquiry-date-range">
                    <label className="inquiry-date-field">
                        <span className="inquiry-date-label">{t("inquiry.startDateLabel")}</span>
                        <input type="date" className="inquiry-date-input" aria-label={t("inquiry.startDateLabel")} value={range.start}
                            onChange={(e) => setRange((p) => ({ ...p, start: e.target.value }))} />
                    </label>
                    <span className="inquiry-date-separator">~</span>
                    <label className="inquiry-date-field">
                        <span className="inquiry-date-label">{t("inquiry.endDateLabel")}</span>
                        <input type="date" className="inquiry-date-input" aria-label={t("inquiry.endDateLabel")} value={range.end}
                            onChange={(e) => setRange((p) => ({ ...p, end: e.target.value }))} />
                    </label>
                    <button type="button" className="inquiry-date-confirm" disabled={!range.start || !range.end || range.start > range.end}
                        onClick={() => onPick(`${range.start} ~ ${range.end}`)}>{t("cf.period.apply")}</button>
                </div>
            )}
        </div>
    );
}

// 시안 sq — 상태 · No.X · 구분 · 세부 · 요청 한 줄(또는 진행 줄). 누르면 상세
export function InquiryCard({ q, go, withNote }) {
    const { lang } = useLanguage();
    const open = () => go(`inq/${q.id}`);
    return (
        <div className="cf-sq" role="button" tabIndex={0} onClick={open}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); } }}>
            {q.status && <StatusTag status={q.status} />}
            <div className="cf-sq-t">
                <b>{[`No.${q.id}`, kindLabel(q, lang)].filter(Boolean).join(" · ")}</b>
                {withNote ? <StateNote item={q} withResult={false} /> : <span>{q.request_content || q.content}</span>}
            </div>
            <i className="fa-solid fa-chevron-right cf-sq-arrow" aria-hidden="true" />
        </div>
    );
}

export function GoInqButton({ go }) {
    const t = useChatText();
    return <button type="button" className="cf-lnk" onClick={() => go("inq")}><i className="fa-regular fa-clipboard" aria-hidden="true" />{t("cf.goInq")}</button>;
}

// 공지 번호 목록
export function PickList({ items, label, onPick }) {
    return (
        <div className="cf-list">
            {items.map((x, i) => (
                <button key={x.id} type="button" className="chatbot-submenu-single" onClick={() => onPick(x)}>
                    <span className="chatbot-submenu-id">{i + 1}</span><span>{label(x)}</span>
                </button>
            ))}
        </div>
    );
}
